import { useList, useDetail, useCreate, useUpdate, fetchApi, useDelete } from "@inmagik/react-crud"
import { Citta } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useCittaList(params: Record<string, string> = {}) {
  return useList<Citta>(`${API_URL}/admin/citta`, {
    query: params,
  })
}

export function useCitta(id: number | undefined) {
  return useDetail<Citta>(`${API_URL}/admin/citta`, id?.toString())
}

export function useCittaCreate() {
  return useCreate<Citta>(`${API_URL}/admin/citta`)
}

export function useCittaUpdate() {
  return useUpdate<Citta>(`${API_URL}/admin/citta`)
}

export function useCittaLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/citta/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Citta>
  }, [])
}

export function useCittaMultiLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/citta?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Citta[] }>
  }, [])
}

export function useCittaDelete() {
  return useDelete(`${API_URL}/admin/citta`)
}
